<template>
  <div class="animated fadeIn">
    <b-card>
      <b-row>
        <b-col sm="12">
          <b-button variant="link" @click="go_list()" class="float-right px-0">クイックガイドExit</b-button>
        </b-col>
      </b-row>
      <hr>
      <b-row>
        <!-- progress bar -->
        <b-col sm="1"></b-col>
        <b-col sm="10">
          <p>
            <StepProgress active-color="black" :steps="steps['EN']" :current-step="status.step" />
          </p>
        </b-col>
        <b-col sm="1"></b-col>
      </b-row>
      <hr>
      <b-row class="step_box mb-4" v-if="status.step != 1">
        <b-col>
          {{steps['EN'][status.step]}}
        </b-col>
      </b-row>
      <b-row class="step_box mb-4" v-else>
        <b-col>
          {{steps['EN'][status.step]}}
          <p>
          <h4>スキャニングのための新しいポリシーを作成</h4>
          <small>
            このステップでは、「クイックスキャン」ポリシーを自動的に生成します。
            あとで新しいポリシーまたはこのポリシーの編集を構成することができます。削除も行うことができます。
          </small>
          </p>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="12">
          <transition-group name="slide-fade">
            <!-- first -->
            <b-form-group v-if="status.step == 0" v-bind:key="0">
              <b-input-group class="text-center">
                <b-input-group-prepend>
                  <b-input-group-append is-text>
                    <div class="checkbox-switch">
                      <input type="checkbox" class="input-checkbox" checked="">
                      <div class="checkbox-animate">
                        <small style="margin-top:2px;" class="checkbox-off">HTTP</small>
                        <small style="margin-top:2px;" class="checkbox-on">HTTPS</small>
                      </div>
                    </div>
                  </b-input-group-append>
                  <b-input-group-text>
                    FQDN
                    <a class="ml-2" href="javascript:void(0);" v-b-tooltip.hover.hover
                      title="www.f1security.co.kr, img.f1security.co.kr, ftp.f1security.co.kr => FQDN is f1security.co.kr">
                      <span class="font_14 text-info"><i class="fas fa-question-circle"></i></span>
                    </a>
                  </b-input-group-text>
                </b-input-group-prepend>
                <b-form-input class="text-center border" type="text" ref="fqdn" id="ph_fqdn"
                  placeholder="FQDN (例 : company.com)" v-model="model.fqdn" @keypress.enter="next()"></b-form-input>
              </b-input-group>
            </b-form-group>
            <!-- seconed -->
            <b-form-group v-if="status.step == 1" v-bind:key="1">
              <b-row>
                <b-col>
                  <strong class="d-inline-block float-left">ポリシー : {{policy_description}}</strong>
                  <b-button class="d-inline-block float-right" v-if="policy_has" variant="link"
                    @click="modal_policy= true">既存ポリシーの利用</b-button>
                </b-col>
              </b-row>
              <hr>
              <b-row>
                <b-col md="2" v-b-tooltip.hover.hover :title="`
                  最初のページから次のページへリンクを移動(パス)して確認するかどうかを入力します。 クイックセットアップのデフォルト値は次のとおりです ${policy.depth}
                  `">
                  <span class="col-form-label">
                     最大パス深度
                  </span>
                  <span class="font_14 text-info"><i class="fas fa-question-circle"></i></span>
                </b-col>
                <b-col md="4">
                  <b-form-input :disabled="true" class="text-center border" type="number" id="ph_limit" :min="10"
                    :max="50000" v-model="policy.limit" :plaintext="true"></b-form-input>
                </b-col>
                <b-col md="2" v-b-tooltip.hover.hover :title="`
                  ページ内を移動するサブリンクの最大数を入力してください。
                  余分なリンクは無視してください。
                  通常、1 つのページに存在するリンクが多すぎる場合は、バランスの取れた方法でチェックされないことを防ぐために、他のページに移動する前に最大ナビゲーション ページに到達することができます。
                  クイックセットアップのデフォルト値は次のとおりです ${policy.links}`">
                  <span class="col-form-label">
                    サブページリンク
                  </span>
                  <span class="font_14 text-info"><i class="fas fa-question-circle"></i></span>
                </b-col>
                <b-col md="4">
                  <b-form-input :disabled="true" class="text-center border" type="number" id="ph_links" :min="1"
                    :max="1000" v-model="policy.links" :plaintext="true"></b-form-input>
                </b-col>
              </b-row>
              <b-row class="mt-4">
                <b-col md="2" v-b-tooltip.hover.hover :title="`
                検査サイトで確認する総ページ数です。
                入力した数値に達したらチェックを終了します。
                1からライセンス制限までの範囲で指定できます。
                クイックセットアップのデフォルト値は次のとおりです ${policy.limit}`">
                  <span class="col-form-label">
                    最大ナビゲーションページ
                  </span>
                  <span class="font_14 text-info"><i class="fas fa-question-circle"></i></span>
                </b-col>
                <b-col md="4">
                  <b-form-input :disabled="true" class="text-center border" type="number" id="ph_links" :min="1"
                    :max="1000" v-model="policy.links" :plaintext="true"></b-form-input>
                </b-col>
                <b-col md="2" v-b-tooltip.hover.hover :title="`
                  ページの読み込みを待つ時間です。
                  1～30の範囲で指定できます。
                  クイックセットアップのデフォルト値は次のとおりです ${policy.timeout}`">
                  <span class="col-form-label">
                    タイムアウト(秒)
                  </span>
                  <span class="font_14 text-info"><i class="fas fa-question-circle"></i></span>
                </b-col>
                <b-col md="4">
                  <b-form-input :disabled="true" class="text-center border" type="number" id="ph_timeout" :min="1"
                    :max="30" v-model="policy.timeout" :plaintext="true"></b-form-input>
                </b-col>
              </b-row>

              <b-row class="mt-4">
                <b-col md="2" v-b-tooltip.hover.hover :title="`
                新しいページに移動するまでの待ち時間です。
                1～10000の範囲で指定できます。
                クイックセットアップのデフォルト値は次のとおりです ${policy.delay}`">
                  <span class="col-form-label">
                    チェック速度(ミリ秒)
                  </span>
                  <span class="font_14 text-info"><i class="fas fa-question-circle"></i></span>
                </b-col>
                <b-col md="4">
                  <b-form-input :disabled="true" class="text-center border" type="number" id="ph_links" :min="0"
                    :max="10000" v-model="policy.delay" :plaintext="true"></b-form-input>
                </b-col>
              </b-row>
            </b-form-group>
            <!-- final -->
            <b-form-group v-if="status.step == 2" v-bind:key="2">
              <b-row>
                <b-col md="1"></b-col>
                <b-col>
                  <span class="text-danger font-weight-light">
                    * 最初のサイト登録が行われ、スキャンが開始された時点で課金が開始されます
                  </span>
                </b-col>
                <b-col>
                  <b-form-checkbox class="mr-n2 mb-n1" v-model="status.agree1"
                    @change="(x) => model.is_start = x && status.agree2 && status.agree3 && status.agree4 ">
                    確認し、承知しました。
                  </b-form-checkbox>
                </b-col>
              </b-row>

              <b-row>
                <b-col md="1"></b-col>
                <b-col>
                  <span class="text-danger font-weight-light">
                    * トラフィックは実際のウェブサイト上で発生します
                  </span>
                </b-col>
                <b-col>
                  <b-form-checkbox class="mr-n2 mb-n1" v-model="status.agree2"
                    @change="(x) => model.is_start = status.agree1 && x && status.agree3 && status.agree4 ">
                    確認し、承知しました。
                  </b-form-checkbox>
                </b-col>
              </b-row>

              <b-row>
                <b-col md="1"></b-col>
                <b-col>
                  <span class="text-danger font-weight-light">
                    詳しくは規約をご覧ください。
                  </span>
                </b-col>
                <b-col>
                  <b-form-checkbox class="mr-n2 mb-n1" v-model="status.agree3"
                    @change="(x) => model.is_start = status.agree1 && status.agree2 && x && status.agree4 ">
                    確認し、承知しました。
                  </b-form-checkbox>
                </b-col>
              </b-row>

              <b-row>
                <b-col md="1"></b-col>
                <b-col>
                  <strong class="text-danger">毎日AMにスケジューリング {{status.interval}}</strong>
                </b-col>
                <b-col>
                  <b-form-checkbox class="mr-n2 mb-n1" v-model="status.agree4"
                    @change="(x) => model.is_start = status.agree1 && status.agree2 && status.agree3 && x ">
                    確認し、承知しました。
                  </b-form-checkbox>
                </b-col>
              </b-row>
              <hr>
              <b-row class="text-center">
                <b-col md="12">
                  <b-form-checkbox class="mr-n2 mb-n1"
                    @change="(x) => { status.agree1 = x; status.agree2 = x; status.agree3 = x; status.agree4 = x }"
                    v-model="model.is_start" ref="agreement">
                    <strong>すべて確認し、承知しました。</strong>
                  </b-form-checkbox>
                </b-col>
              </b-row>
            </b-form-group>

            <!-- final -->
            <b-form-group v-if="status.step == 3" v-bind:key="2">
              <center>
                <p>クイック構成が完了しました</p>
                <p>まもなく検査が開始されます</p>
                <p></p>
                <b-button variant="link" @click="go_site()" class="px-0">サイトをリセットします </b-button>
                or
                <b-button variant="link" @click="go_policy()" class="px-0">検査ポリシーを変更します </b-button>
              </center>
            </b-form-group>
          </transition-group>
        </b-col>
      </b-row>
      <hr>
      <!-- 마지막에는 이전이 없어야 함 -->
      <b-row>
        <b-col>
          <b-button v-if="status.step > 0 && status.step < steps['EN'].length - 1" block size="sm" variant="info"
            @click="prev()"> 前へ </b-button>
          <!-- <b-button v-else  block size="sm" variant="success" @click="go_list">完了</b-button> -->
        </b-col>
        <b-col>
          <b-button v-if="status.step < steps['EN'].length - 1" block size="sm" variant="primary" @click="next()">Next
          </b-button>
        </b-col>
      </b-row>
    </b-card>
    <link rel="stylesheet" href="custom/wmds.site.quick.setup.css">
    <!-- delete modal -->
    <b-modal size="xl" title="Choice 選択ポリシー" class="modal-primary" v-model="modal_policy" @ok="modal_policy = false"
      header-bg-variant="primary" ok-variant="primary">
      <PolicyList :use_view="false"
        @selected="x => { policy = Object.assign({}, policy, x.policy); policy_description = x.description; modal_policy = false; policy_selected = true; status.policy_id = x.id }" />
    </b-modal>
  </div>
</template>
<style>
  .step-progress__step-label {
    font-size: 1.3em !important;
  }

  @media (max-width: 1200px) {
    .step-progress__step-label {
      font-size: 0.9em !important;
    }
  }

  @media (max-width: 767px) {
    .step-progress__step-label {
      font-size: 0.6em !important;
    }
  }
</style>
<script>
  import App from './app.js'; export default Object.assign({}, App);
</script>
